import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getUserLessonProgressRpc } from 'academy-common-lib/features/userProgress/userProgressBFFRpc';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const BASE_URI_PROGRESS = '/academy/learning-center/progress/v1';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
const GET_LESSON_PROGRESS = registerQuery({
  fieldName: 'lessonProgress',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return chirpClient.call(getUserLessonProgressRpc, {
      timeout: 25000,
      request: {
        lessonId: Number(lessonId)
      }
    });
  }
});
export const useLessonProgressById = (lessonId, skip) => {
  const {
    data: lessonProgressById,
    loading: lessonProgressByIdLoading,
    error: lessonProgressByIdError
  } = useQuery(GET_LESSON_PROGRESS, {
    variables: {
      lessonId: Number(lessonId)
    },
    skip: !lessonId || skip,
    fetchPolicy: 'cache-first',
    onError: error => {
      throw new Error(error.message);
    }
  });
  return {
    lessonProgressById,
    lessonProgressByIdLoading,
    lessonProgressByIdError
  };
};